//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


export default {
  data() {
    return {
       isComplex:false,
       isMousedown:false,
       isMousedownList:[],    
       isMouseup:false,
       isMouseupList:[],
       buildList:[],
       saleStatusList:[],
       isTransverseVue:true,
       roomIds:[],
       isEnds:false,
       isRefreshs:false
      //  overflow: scroll;
    };
  },
  created() {
    this.handleToNextStep()
  },
  computed:{
      
  },
  watch:{

     buildBeanList:{
       handler:function(newval,oldval){
            this.buildList=this.buildBeanList
           
       },
       deep: true
     },
     isEnd:{
       handler:function(newval,oldval){
           console.log('this.isEnds',this.isEnd,newval,oldval)
            this.isEnds=this.isEnd
       },
       deep: true
     },
     isRefresh:{
       handler:function(newval,oldval){
          console.log('this.isEnds',this.isRefresh,newval,oldval)
            this.isRefreshs=this.isRefresh
            if(this.isRefreshs){
               this.buildList.forEach(i=>{
                  i.floorBeanList.forEach(ii=>{
                     ii.unitBeanList.forEach(iii=>{
                        iii.roomBeanList.forEach(iiii=>{
                           iiii.clickFlag=false
                        })
                     })
                  })
               })
               this.roomIds=[]
               this.isEnds=false
               this.isEnd=false
               this.isRefreshs=false
               this.isRefresh=false
               return
            }
       },
       deep: true
     },
     saleStatusBeanList:{
       handler:function(newval,oldval){
            this.saleStatusList=this.saleStatusBeanList
       },
       deep: true
     },
     isTransverse:{
       handler:function(newval,oldval){
            this.isTransverseVue=this.isTransverse
            console.log('方向',this.isTransverseVue)
            if(this.isTransverse==null||this.isTransverse==undefined){
               this.isTransverseVue=true
            }
       },
       deep: true
     },
  },
  props: {
    buildBeanList: Array,
    saleStatusBeanList:Array,
    model: Object,
    getLangMsg: Function,
    invoke: Function,
    isTransverse:Boolean,
    isEnd:Boolean,
    isRefresh:Boolean
  },
  methods: {
    handleToNextStep: function () {
      console.log('init_data')
      this.invoke('invokeCustomEvent',{content:{ type: 'init_data', value:''}})
    },
 
    changeHoldname(e,num,n,nn){
      console.log(e.target.value,num,n,nn,'e')
      //  if(e.target.value){
           let value={
            unitHoldId:this.buildList[num].buildHeadBean.unitBeanList[n].unitHoldBeanList[nn].id,
            unitHoldName:this.buildList[num].buildHeadBean.unitBeanList[n].unitHoldBeanList[nn].name
         }
         let parm={content:{ type:'edit_unitholdname', value:value}}
         console.log('传给后台的参数',parm)
         this.invoke('invokeCustomEvent',parm) 
      //  }
    },

    getBg(color){
       let style=''
       let bg='background-color:'+color+';';
       style=bg;
        if(color=='#fff'||color=='#FFF'||color=='#FFFFFF'||color=='#ffffff'){
            let border='border:1px solid #CECECE;width:8px;height:8px;';
            style=style+border
        }
      // console.log('color',color,'style',style)
      return style
    },
    getItemBg(salesStatus,init){
       let color='#fff';
      //  console.log('this.saleStatusBeanList',this.saleStatusBeanList)
        if( this.saleStatusBeanList != undefined ||  this.saleStatusBeanList > 0){
           this.saleStatusBeanList.forEach(i=>{
               if(i.number==salesStatus){
                  color=i.color
               }
           })
        }
       if(!init){
          color='#fff';
       }
       let style=''
       let bg='background-color:'+color+';';
       style=bg
        if(color=='#fff'||color=='#FFF'||color=='#FFFFFF'||color=='#ffffff'){
            let border='color:#212121;';
             if(init){
                  border+='border:1px solid #ccc;box-sizing: border-box;line-height:20px;'
              }
            style=style+border
        }
       return style
    },
     getWidth(n,salesStatus,init,isMore){
         
        if(!n){
           n=1
        }
        let w=60*n+4*(n-1);
      //   let m=2*n;
        let wStyle='width:'+w+'px;';
        if(isMore==1){
           wStyle='width:102px;';
        }
        if(isMore==2){
           wStyle='width:138px;';
        }
        let mStyle='margin:2px 2px;';
        let style=this.getItemBg(salesStatus,init)
      //   console.log('wStyle+mStyle+style',wStyle+mStyle)
        return wStyle+mStyle+style
     },
    remove(arr, item) {
         for(var i=arr.length-1;i>=0;i--)
            {
            if(arr[i]==item)
               {
               arr.splice(i,1);
               }
            }
         return arr;
      },
     mouseClick(e,num,n,nn,nnn,id){
         this.buildList[num].floorBeanList[n].unitBeanList[nn].roomBeanList[nnn].clickFlag=!this.buildList[num].floorBeanList[n].unitBeanList[nn].roomBeanList[nnn].clickFlag;
         // console.log(e.target.value,num,n,nn,'e')
      //  if(e.target.value){
         console.log('mouseClick',this.isEnds)
         if(this.isEnds){
            this.buildList.forEach(i=>{
               i.floorBeanList.forEach(ii=>{
                  ii.unitBeanList.forEach(iii=>{
                     iii.roomBeanList.forEach(iiii=>{
                         iiii.clickFlag=false
                     })
                  })
               })
            })
            this.roomIds=[]
            this.isEnds=false
            this.isEnd=false
            this.mouseClick(e,num,n,nn,nnn,id)
            return
         }
         if(this.buildList[num].floorBeanList[n].unitBeanList[nn].roomBeanList[nnn].clickFlag){
             this.roomIds.push(id)
             console.log('111',this.roomIds)
         }else{
              
              this.remove(this.roomIds,id)
              console.log('222',this.roomIds)
         }
        
            let value={
               roomIds:this.roomIds
            }
            let parm={content:{ type:'multi_clickroom', value:value}}
            console.log('传给后台的参数',parm)
            this.invoke('invokeCustomEvent',parm) 
         
     }
  }
};
